import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { readPartnerVerifiedFlag } from "./visitModels/authFlags";

const MCTProtectedRoute = ({ children }) => {
  // Only check partnerVerified
  if (!readPartnerVerifiedFlag()) {
    return <Navigate to="/partner/profile" replace />;
  }

  return children ? children : <Outlet />;
};

export default MCTProtectedRoute;
